import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 12px;
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const InfoWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ActionWrapper = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.black9};
  font-weight: 500;
  line-height: 20px;
  cursor: pointer;
  &:hover {
    color: ${({ theme }) => theme.colors.green6};
  }
`;
